export default "__VITE_ASSET__DVmL2GAX__"